console.log('ROOM SPRAY OFFER LOADED');

let allProducts = [];

/* =========================
LOAD PRODUCTS
========================= */

async function loadRoomSprays() {

const container = document.querySelector(
'.room-spray-products-grid'
);

if (!container) return;

try {


container.innerHTML = `
  <div class="offer-skeleton"></div>
  <div class="offer-skeleton"></div>
  <div class="offer-skeleton"></div>
  <div class="offer-skeleton"></div>
`;

const response = await fetch(
  '/collections/signature-room-spray-1'
);

const html = await response.text();

const parser = new DOMParser();

const doc = parser.parseFromString(
  html,
  'text/html'
);

const links = [
  ...new Set(
    [...doc.querySelectorAll(
      'a[href*="/products/"]'
    )].map(el => el.href)
  )
];

const products = await Promise.all(

  links.map(async url => {

    try {

      const handle =
        url
        .split('/products/')[1]
        ?.split('?')[0];

      const product =
        await fetch(
          `/products/${handle}.js`
        ).then(r => r.json());

      if (
        product.tags &&
        product.tags.includes(
          'room-spray-offer'
        )
      ) {
        return product;
      }

    } catch(e){}

    return null;

  })

);

const seen = new Set();

allProducts = products.filter(product => {

  if(!product) return false;

  if(seen.has(product.handle))
    return false;

  seen.add(product.handle);

  return true;

});

renderProducts();


} catch(err){


console.log(err);


}

}

/* =========================
RENDER PRODUCTS
========================= */

function renderProducts(){

const container =
document.querySelector(
'.room-spray-products-grid'
);

if(!container) return;

container.innerHTML =


allProducts
.slice(0,4)
.map(product => `

  <div class="offer-product">

    <img
      src="${product.featured_image}"
      loading="lazy"
      alt="${product.title}"
    >

    <h4>${product.title}</h4>

    <button
      class="offer-add-btn"
      data-variant="${product.variants[0].id}">
      Add To Cart
    </button>

  </div>

`).join('');


}

/* =========================
PROGRESS
========================= */

async function updateOfferProgress(){

const cart =
await fetch('/cart.js')
.then(r => r.json());

let qty = 0;

cart.items.forEach(item => {


if(
  item.product_type &&
  item.product_type.toLowerCase() ===
  'room spray'
){
  qty += item.quantity;
}


});

const targetQty = 3;

const remaining =
Math.max(
0,
targetQty - qty
);

const percent =
Math.min(
(qty / targetQty) * 100,
100
);

document.querySelector(
'.offer-message'
).innerHTML =


qty >= targetQty

? '🎉 Congratulations! FREE Spray Unlocked'

: `Only ${remaining} more room spray${remaining > 1 ? 's' : ''} needed to claim your FREE spray`;


document.querySelector(
'.offer-progress'
).innerHTML = `


<div class="progress-bar">
  <span style="width:${percent}%"></span>
</div>

<div class="progress-label">
  ${qty}/3 Added
</div>


`;

return qty;

}

/* =========================
CLICK EVENTS
========================= */

document.addEventListener(
'click',
async function(e){


/* ADD PRODUCT */

const addBtn =
  e.target.closest(
    '.offer-add-btn'
  );

if(addBtn){

  addBtn.disabled = true;
  addBtn.innerText =
    'Adding...';

  try {

    await fetch(
      '/cart/add.js',
      {
        method:'POST',
        headers:{
          'Content-Type':
          'application/json'
        },
        body:JSON.stringify({
          id:addBtn.dataset.variant,
          quantity:1
        })
      }
    );

    const qty =
      await updateOfferProgress();

    document.documentElement.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        { bubbles:true }
      )
    );

    addBtn.innerText =
      'Added ✓';

    if(qty >= 3){

      setTimeout(() => {

        sessionStorage.setItem(
          'roomSprayOpenCart',
          'true'
        );

        location.reload();

      },1500);

      return;
    }

    setTimeout(() => {

      addBtn.innerText =
        'Add To Cart';

      addBtn.disabled = false;

    },1000);

  } catch(err){

    console.log(err);

  }

  return;
}

/* VIEW MORE */

if(
  e.target.closest(
    '.offer-load-more-btn'
  )
){

  window.location.href =
  '/collections/signature-room-spray-1';

  return;

}

/* CLOSE POPUP */

if(
  e.target.closest(
    '.skip-offer-btn'
  )
  ||
  e.target.closest(
    '.room-spray-overlay'
  )
){

  document
  .getElementById(
    'roomSprayOffer'
  )
  ?.classList.remove(
    'active'
  );

}


}
);

/* =========================
OPEN POPUP
========================= */

if(
window.location.pathname.includes(
'ss-room-spray'
)
){

document.addEventListener(
'click',
function(e){


  const submitBtn =
    e.target.closest(
      'button[type="submit"]'
    );

  if(!submitBtn) return;

  setTimeout(
    async () => {

      const cart =
        await fetch(
          '/cart.js'
        )
        .then(r => r.json());

      const hasRoomSpray =
        cart.items.some(item =>

          item.product_type &&
          item.product_type
          .toLowerCase() ===
          'room spray'

        );

      if(hasRoomSpray){

        document
        .getElementById(
          'roomSprayOffer'
        )
        ?.classList.add(
          'active'
        );

        await loadRoomSprays();

        await updateOfferProgress();

      }

    },
    1500
  );

}


);

}

/* =========================
REOPEN CART
========================= */

window.addEventListener(
'load',
() => {


if(
  sessionStorage.getItem(
    'roomSprayOpenCart'
  ) === 'true'
){

  sessionStorage.removeItem(
    'roomSprayOpenCart'
  );

  setTimeout(() => {

    const cartBtn =

      document.querySelector(
        '[aria-controls*="cart"]'
      )

      ||

      document.querySelector(
        '.header__cart-toggle'
      )

      ||

      document.querySelector(
        'a[href="/cart"]'
      );

    if(cartBtn){
      cartBtn.click();
    }

  },1200);

}


}
);
